import type {ReactNode, MouseEventHandler} from 'react'
import {TableCell} from '@/components/ui/table'
import {cn} from '@/lib/utils'

type CellTone =
    | 'innerNode'
    | 'globalRoot'
    | 'personalRoot'
    | 'subtle'
    | 'mutedBackground'

/* eslint-disable i18next/no-literal-string -- CSS class constants */
const toneClass: Record<CellTone, string> = {
    innerNode: 'font-medium border-l-2 border-l-muted-foreground/20',
    globalRoot: 'font-medium border-l-2 border-l-blue-500/70',
    personalRoot: 'font-medium border-l-2 border-l-muted-foreground/15',
    subtle: 'border-l-2 border-l-muted-foreground/10',
    mutedBackground: 'bg-muted/30 py-3',
}
/* eslint-enable i18next/no-literal-string */

interface IndentedTableCellProps {
    depth: number
    sortable?: boolean
    indent?: number
    basePadding?: number
    colSpan?: number
    tone?: CellTone
    children?: ReactNode
    onClick?: MouseEventHandler<HTMLTableCellElement>
}

export function IndentedTableCell({
    depth,
    sortable,
    indent = 32,
    basePadding,
    colSpan,
    tone,
    children,
    onClick,
}: IndentedTableCellProps) {
    const fallbackBase = sortable ? 4 : 12
    const paddingLeft = depth * indent + (basePadding ?? fallbackBase)
    return (
        <TableCell
            className={cn(tone && toneClass[tone])}
            colSpan={colSpan}
            onClick={onClick}
            style={{paddingLeft: `${paddingLeft}px`}}
        >
            {children}
        </TableCell>
    )
}
